import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import TableWithFilters from "./TableWithFilters"; // eslint-disable-next-line require-await

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode) {
    var readData, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-".concat(prop));
              return data ? JSON.parse(data) : null;
            };

            props = {
              data: readData("table-data"),
              filtersHideSelectedOptions: readData("filters-hide-selected-options"),
              filtersNoOptionsMessage: readData("filters-no-options-message"),
              filtersPlaceholder: readData("filters-placeholder"),
              infoText: readData("info-text"),
              noResultsMessage: readData("no-results-message"),
              pagesNavigableOnSide: readData("pages-navigable-on-side"),
              paginationResultSummaryText: readData("pagination-result-summary-text"),
              rowsPerPage: readData("rows-per-page"),
              subtitleHeadingRank: readData("subtitle-heading-rank"),
              title: readData("title"),
              titleHeadingRank: readData("title-heading-rank"),
              headerScope: domNode.getAttribute("data-header-scope")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(TableWithFilters, props));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;